import React, { FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import queryString from "query-string";
import { Link, useHistory } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import RequestTable from "./RequestTable";
import { DEFAULT_PER_PAGE } from "../../constants/common";
import { PaymentRequestModel, SearchModel } from "../../models/PaymentRequestModel";
import { PaginateModel } from "../../models/PaginateModel";
import { HeaderModel, ModalModel } from "../../models/CommonModel";
import { createRequest, getList, getStoreDebt, updateRequest, updateRequestStatus } from "./PaymentRequestCRUD";
import { AsyncSelect2 } from "../../../_metronic/partials/select/AsyncSelect2";
import { STORES_ENDPOINT } from "../../constants/endpoints";
import { PaginationHeader } from "../../../_metronic/partials/pagination/PaginationHeader";
import { PaginationLength } from "../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../_metronic/partials/pagination/Paginate";
import ConfigModal from "../../components/Modal/ConfigModal";
import PaymentRequestModal from "./PaymentRequestModal";
import { Toast } from "../../modules/common/helper";
import PaymentRequestEditModal from "./PaymentRequestEditModal";
import { formatPrice } from "../../selectors";

const PaymentRequest: FC = () => {

    const initRange:any = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        status: '',
        start_date: initRange[0],
        end_date: initRange[1],
    }
    const intl = useIntl();
    const history = useHistory();
    const searchHistory = history.location.search;
    const fp = useRef<any>(null);
    const [search, setSearch] = useState<SearchModel>(initSearch)
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<PaymentRequestModel>>();
    const [subTotal, setSubtotal] = useState<number>(0)
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [selecetedStore, setSelectedStore] = useState<any>(null)
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const [paymentRequestModal, setPaymentRequestModal] = useState<ModalModel>({
        show: false,
        mode: 'add'
    })

    const [paymentRequestEditModal, setPaymentRequestEditModal] = useState<ModalModel>({
        show: false,
        mode: 'add'
    })

    const parseParams = (params: SearchModel) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }


    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))

    useEffect(() => {
        document.title = 'Sento Supplier - Yêu cầu thanh toán';
    })

    useEffect(() => {
        const params = { ...search, ...initParams}
        getRequestList(params);
        setSearch(params)
    }, [])

    const handlePageLengthChange = (e: any) => {
        getRequestList({ ...search, page: 1, per_page: +e.target.value })
    }

    const handlePageChange = (data: any) => {
        getRequestList({ ...search, page: data.selected + 1 })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getRequestList({ ...search, page: 1 })

    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        setSearch({
            ...initSearch,
        });
        setSelectedStore(null)
        getRequestList({ ...initSearch })
    }

    const getRequestList = async (params: SearchModel) => {
        let searchQ = {...params};
        const {data: resData} = await getList(searchQ);
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        setDataPaginate(resData?.paginate_data);
        setSubtotal(resData?.sub_total);
        setSearch(params ?? {});
        if (fp.current && fp.current.flatpickr) {
            fp.current.flatpickr.setDate([moment(params.start_date).toDate(), moment(params.end_date).toDate()]);
        }
    }

    const header: HeaderModel[] = [
        {
            label: 'Mã yêu cầu',
            style: { minWidth: "100px" },
            field: 'request_code',
            sortable: true
        },
        {
            label: 'Cửa hàng',
            style: { minWidth: "150px" },
            field: 'store',
            sortable: false
        },
        {
            label: 'Số tiền',
            style: { minWidth: "150px" },
            field: 'amount',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'WAREHOUSE.STATUS' }),
            style: { minWidth: "80px" },
            field: 'status',
            sortable: true
        },
        {
            label: 'Phương thức thanh toán',
            style: { minWidth: "100px" },
            field: 'payment_status',
            sortable: true
        },
        {
            label: 'Ngày tạo',
            style: { minWidth: "150px" },
            field: 'created_at',
            sortable: true
        },
        {
            label: 'Chứng từ thanh toán',
            style: { minWidth: "150px" },
            field: 'payment_docs',
            sortable: true
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getRequestList({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const handleCreateRequest = async (values: any) => {
        try {
            await createRequest(values);
            setPaymentRequestModal({
                ...paymentRequestModal,
                show: false
            })
            getRequestList({...initSearch});
        } catch (err: any) {
            Toast.fire({
                icon: 'error',
                title: 'Tạo yêu cầu không thành công!'
            })
        }
    }

    const handleUpdateRequest = async (values: any) => {
        try {
            await updateRequest(values);
            setPaymentRequestEditModal({
                ...paymentRequestEditModal,
                show: false
            })
            getRequestList({...initSearch});
        } catch (err: any) {
            Toast.fire({
                icon: 'error',
                title: 'Đã có lỗi xảy ra, vui lòng thử lại sau!'
            })
        }
    }

    const handleViewRequest = (item: PaymentRequestModel) => {
        setPaymentRequestEditModal({
            ...paymentRequestEditModal,
            data: item,
            show: true
        })
    }

    const handleUpdateRequestStatus = async (status: string, requestId?: number) => {
        if (!requestId) {
            return;
        }
        try {
            await updateRequestStatus(requestId, status);
            setPaymentRequestEditModal({
                ...paymentRequestEditModal,
                show: false
            })
            getRequestList({...initSearch});
        } catch (err: any) {
            Toast.fire({
                icon: 'error',
                title: 'Đã có lỗi xảy ra, vui lòng thử lại sau!'
            })
        }
    }
    return <div className="card">
        <div className="card-header py-4">
            <div className="col-md-12">
                <form onSubmit={handleSearch}>
                    <div className="row">
                        <div className='col-md-3 mb-2'>
                            <label className='form-label'>Cửa hàng</label>
                            <AsyncSelect2
                                sourceUrl={`${STORES_ENDPOINT}`}
                                defaultOptions
                                default
                                name='store_id'
                                value={selecetedStore}
                                onChange={(selectedOption: any) => {
                                    setSearch({ ...search, store_id: selectedOption ? selectedOption.value : ''})
                                    setSelectedStore(selectedOption)
                                }}
                            />
                        </div>
                        <div className="col-md-3 mb-2">
                            <label className="form-label">{intl.formatMessage({id: 'ORDER.STATUS'})}</label>
                            <select
                                className="form-select"
                                value={search.status}
                                onChange={(e) => setSearch({...search, status: e.target.value})}
                                name="status"
                            >
                                <option value="">Tất cả</option>
                                <option value="pending">Đang chờ xử lý</option>
                                <option value="new">Đã thanh toán</option>
                                <option value="confirmed">Đã xác nhận</option>
                                <option value="canceled">Đã hủy</option>
                            </select>
                        </div>
                        <div className='col-md-3 mb-2'>
                            <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                            <Flatpickr
                                ref={fp}
                                onChange={(date) => {
                                    let startDate = moment(date[0]).format('YYYY-MM-DD');
                                    let endDate = moment(date[1]).format('YYYY-MM-DD');
                                    setSearch({ ...search, start_date: startDate, end_date: endDate });
                                }}
                                options={{
                                    mode: "range",
                                    dateFormat: 'd-m-Y',
                                    enableTime: false,
                                    locale: Vietnamese,
                                    defaultDate: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
                                }}
                                className='form-control'
                                placeholder=''
                            />
                        </div>
                        <div className="row btns-group">
                            <button
                                className="col-auto btn btn-primary mt-8 me-2"
                                onClick={handleSearch}
                            >
                                <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                            </button>
                            <button
                                className="col-auto btn btn-danger mt-8 me-2"
                                type="button"
                                onClick={handleClearSearch}
                            >
                                <i className="bi bi-eraser-fill fs-1"></i> Re-search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="card-body">
            <div className="justify-content-between align-items-center my-3 row">
                <div className='col-md-5'>
                    <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                        total={dataPaginate?.meta?.total || 0} />
                </div>
                <div className='col-md-7 text-end btns-group p-0'>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => setPaymentRequestModal({...paymentRequestModal, show: true, mode: 'add'})}
                    >
                        <i className="bi bi bi-plus fs-4"></i> Tạo yêu cầu
                    </button>
                </div>
                <div className='col-12 col-md-4'>
                    <h3>Tổng giá trị: <span className="text-bold">{formatPrice(subTotal)} VNĐ</span></h3>
                </div>
            </div>
            <RequestTable
                data={dataPaginate?.data || []}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                header={header}
                hideCols={hideCols}
                handleSort={handleSort}
                viewRequest={handleViewRequest}
            />
        </div>
        <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
        <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        />
        <PaymentRequestModal
            {...paymentRequestModal}
            onClose={() => { setPaymentRequestModal({...paymentRequestModal, show: false})} }
            onSubmit={handleCreateRequest}
        />
        <PaymentRequestEditModal
            {...paymentRequestEditModal}
            onClose={() => { setPaymentRequestEditModal({...paymentRequestEditModal, show: false})} }
            onSubmit={handleUpdateRequest}
            onUpdateStatus={handleUpdateRequestStatus}
        />
    </div>
}
export default PaymentRequest;